export type includeFilter =
    | 'query'
    | 'subject'
    | 'opener'
    | 'app'
    | 'type'
    | 'status'
    | 'assignee'
    | 'resource-type'
    | 'resource'
    | 'show-only-completed-tasks'
    // | 'app-user-with-context' // is very broken because these aren't uniquified per app atm
    | 'older-than'
    | 'account-type'
    | 'step-approval-types'
    | 'user-employment-statuses'
    | 'created-between'
    | 'status-toggle'
    | 'pending-action'

export type taskSearchFilters = Array<includeFilter>

export const defaultDisplayFilters: Array<includeFilter> = [
    'query',
    'subject',
    'opener',
    'app',
    'type',
    'status',
    'assignee',
    'resource-type',
    'resource',
    'older-than',
    'account-type',
    'created-between',
]
